// src/theme/colors.ts
export const Colors = {
  color1: "--color-1",
  color2: "--color-2",
  color3: "--color-3",
  color4: "--color-4",
  colorR: "--color-R",
  colorV: "--color-V",
  colorB: "--color-B",
  colorW: "--color-W",
  colorG: "--color-G",
  colorN: "--color-N",
  colorI: "--color-I",
} as const;

export const getColor = (color: keyof typeof Colors) =>
  getComputedStyle(document.documentElement)
    .getPropertyValue(Colors[color])
    .trim();

export function getCSSVarValue(varName:string) {
  if (!varName.startsWith("--")) {
    console.warn("La variable CSS doit commencer par '--'");
    return "";
  }

  const root = document.documentElement;
  return getComputedStyle(root)
    .getPropertyValue(varName)
    .trim();
}
